import createAxios from "./httpCommon";

export const fetchReviews = async ({ page = 1, limit = 10 } = {}) => {
  const axios = await createAxios();
  const response = await axios.get(`/reviews?page=${page}&limit=${limit}`);
  return response?.data ?? null;
};

export const fetchReviewableOrders = async () => {
  const axios = await createAxios();
  const response = await axios.get("/reviews/orders");
  return response?.data ?? null;
};

export const fetchOrderReviewState = async (orderId) => {
  const axios = await createAxios();
  const response = await axios.get(`/reviews/orders/${orderId}`);
  return response?.data ?? null;
};

export const submitOrderReview = async ({ orderId, payload }) => {
  const axios = await createAxios();
  const response = await axios.post(`/reviews/orders/${orderId}`, payload);
  return response?.data ?? null;
};

export const deleteOrderReview = async (orderId) => {
  const axios = await createAxios();
  const response = await axios.delete(`/reviews/orders/${orderId}`);
  return response?.data ?? null;
};

export const fetchProductRating = async (productId) => {
  const axios = await createAxios();
  const response = await axios.get(`/ratings/products/${productId}`);
  return response?.data || null;
};

export const fetchFeaturedReviews = async () => {
  const axios = await createAxios();
  const response = await axios.get("/reviews/featured");
  return response?.data ?? null;
};
